import { SmartContext } from '../xstate/smart.xstate-utils';
import { generateBaseURLsToTools } from './generate-base-urls/generate-base-urls';

export const handleGoHome = (accountId: SmartContext['accountId']) => {
  const url = `${generateBaseURLsToTools(window.location).Manager}${accountId ? `/organization/${accountId}` : ''}`;

  window.location.href = url;
};
